/**
 * Default post sign-in path when no redirect param is present.
 * Re-exported from `auth.ts` for the app; `env.mjs` imports this file directly
 * so Node ESM (e.g. `next.config.mjs`) resolves it without a TS build step.
 */
export const DEFAULT_SIGN_IN_REDIRECT = '/appointments';
